export const getCookieJWT = (): string => 
  document.cookie.split(';').reduce((jwt, name) => {
    const [key, value] = name.split('=');
    if (key.trim() == 'jwt') {
      jwt = value;
    }
    return jwt
  }, '');

export const resetCookies = () => {
    document.cookie.split(';').forEach((_cookie) => {
        document.cookie = 
            _cookie
                .replace(/^ +/, "")
                .replace(/=.*/, "=;expires=" + new Date().toUTCString() + ";path=/");
    })
  }